import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-payid.svg";
import * as styles from "./Icon.module.scss";

type PayIdProps = React.SVGProps<SVGSVGElement>;

export const PayId = ({ className, ...props }: PayIdProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
